<template>
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-12">
        <h4
          class="zoom float-start"
          @click="viewInvoice">
          <span>{{invoice.invoice_id}}</span>
        </h4>
        <button
          v-if="!inList"
          class="btn btn-primary btn-sm float-end"
          @click="emailToggle">
          <i class="fa fa-envelope"/>
          Email&nbsp;
          <span v-if="invoice.print_status == 'N'">Invoice</span>
          <span v-if="invoice.print_status == 'P'">Acknowledgement</span>
        </button>
        <div class="clearfix"/>
        <strong
          v-if="invoice.open"
          class="badge bg-success">
          <i class="fa fa-envelope-open-text"/>
          Open Invoice
        </strong>
        <strong
          v-if="invoice.print_status == 'P'"
          class="badge bg-info ms-2">
          <i class="fa fa-hourglass-half"/>
          In Process
        </strong>
      </div>
      <div class="col-md-2">
        <small>
          <strong>Invoice Date:</strong>
          {{moment(invoice.post_date).format('YYYY-MM-DD')}}
        </small>
      </div>
      <div class="col-md-2">
        <small>
          <strong>Amount:</strong>
          {{numeral(total).format('$0,0.00')}}
        </small>
      </div>
      <div class="col-md-2">
        <small>
          <strong>Payment:</strong>
          {{numeral(payment).format('$0,0.00')}}
        </small>
      </div>
      <div class="col-md-2">
        <small>
          <strong>Payment Date:</strong>
          {{paymentDate ? moment(paymentDate).format('YYYY-MM-DD') : 'N/A'}}
        </small>
      </div>
      <div class="col-md-2">
        <small>
          <strong>Balance:</strong>
          {{numeral(balance).format('$0,0.00')}}
        </small>
      </div>
      <div class="col-md-2">
        <small>
          <strong>PO#</strong>
          {{invoice.customer_po}}
        </small>
      </div>
    </div>   
    <hr/>
  </div>
</template>

<script>
  import {currencyConverter} from '../../../../shared/currencyConverter'
  
  export default {
    props: ['invoice', 'emailData'],
    methods:{
      viewInvoice(){
        this.$store.dispatch('viewInvoice', this.invoice.invoice_id)
        window.scrollTo(0,0)
      },
      emailToggle(){
        let invoice = {
          text: this.invoice.invoice_id,
          value: this.invoice.invoice_id,
          invoice: this.invoice.print_status == 'N'
        }
        this.$emit('emailToggle', invoice)
      },
      inEmailList(id){
        let inList = _.includes(this.emailData.orderList, id)
        if(inList == true){
          return true
        }else{
          return false
        }
      }
    },
    computed:{
      inList(){
        let orderList = _.map(this.emailData.orderList, o => o.text)
        return _.includes(orderList, this.invoice.invoice_id)
      },
      total(){
        if(this.invoice.foreign_currency == 'CAD'){
          return currencyConverter(this.invoice.exchange_rate, this.invoice.amount)
        }
        return this.invoice.amount
      },
      payment(){
        if(this.invoice.details?.foreign_currency == 'CAD'){
          return currencyConverter(this.invoice.details.exchange_rate, this.invoice.details.payment_amount)
        }
        return this.invoice.details?.payment_amount
      },
      paymentDate(){
        return this.invoice.details?.payment_date
      },
      balance(){
        if(this.invoice.details?.foreign_currency == 'CAD'){
          return currencyConverter(this.invoice.details.exchange_rate, this.invoice.details.balance)
        }
        return this.invoice.details?.balance
      }
    }
  }
</script>

<style scoped>
  .zoom{ transition: all .2s ease-in-out; }
  .zoom:hover{
    transform: scale(1.02);
    cursor:pointer;
  }
</style>